module.exports = __webpack_public_path__ + "img/ajolito-hechizero.1810429b.png";